import { render, staticRenderFns } from "./Anzan.vue?vue&type=template&id=4c02a931&scoped=true&"
import script from "./Anzan.vue?vue&type=script&lang=ts&"
export * from "./Anzan.vue?vue&type=script&lang=ts&"
import style0 from "./Anzan.vue?vue&type=style&index=0&id=4c02a931&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c02a931",
  null
  
)

export default component.exports